import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

import UserAvatar from '@/components/widgets/UserAvatar';
import { computed } from 'vue';
import { useStore } from 'vuex';
import useTranslate from '@/utilities/composables/useTranslate';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditorAvatars',
  props: {
    sessionAvatarsPosition: {},
    users: {},
    status: {}
  },
  setup(__props: any) {

const store = useStore();
const { translate } = useTranslate();

const props = __props;

const avatarsPositionStyle = computed(() => {
  return Object.keys(props.sessionAvatarsPosition || {}).length > 0
    ? props.sessionAvatarsPosition
    : '';
});

const networkStatus = computed(() => store.getters.getOnline);

const isStatusOnline = computed(() => {
  // If indicated as online by service worker, check if collab is connected, otherwise it's offline
  return networkStatus.value ? !props.status || props.status === 'connected' : false;
});

const statusText = computed(() => {
  return translate(isStatusOnline.value ? 'online' : 'disconnected');
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: "editor-avatars st-floating-avatars",
    style: _normalizeStyle(avatarsPositionStyle.value)
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (u, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `${u.id}-${i}`,
        class: "relative"
      }, [
        _createVNode(_unref(UserAvatar), {
          class: _normalizeClass({ 'opacity-50': !isStatusOnline.value }),
          size: "small",
          member: u,
          "show-user-color": true
        }, null, 8, ["class", "member"]),
        _cache[0] || (_cache[0] = _createTextVNode()),
        _withDirectives(_createElementVNode("div", {
          class: _normalizeClass(['editor-status-indicator', isStatusOnline.value ? 'bg-green-500' : 'bg-red-500'])
        }, null, 2), [
          [_directive_tooltip, { content: statusText.value, placement: 'bottom' }]
        ])
      ]))
    }), 128))
  ], 4))
}
}

})